import { BaseError } from './BaseError';
import { ErrorConstants } from './constants';

export class ExpiredSessionError extends BaseError {
    constructor() {
        super(ErrorConstants.expiredSession, 'Session Expired');
    }
}
